"use client";

import { Outlet } from "react-router-dom";
import { AuthProvider } from "@/providers/auth-provider";
import { ExperimentProvider } from "@/providers/experiment-provider";
import { I18nProvider } from "@/providers/i18n-provider";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { ThemeApplier } from "@/providers/theme-applier";

/**
 * Root layout route element.
 *
 * Hosts the providers that depend on React Router context — `AuthProvider`
 * calls `useNavigate`, `ThemeApplier` calls `useLocation`. Router hooks only
 * resolve inside the route tree rendered by `<RouterProvider>`, so these
 * providers cannot wrap `<RouterProvider>` in `app.tsx`; they live here as the
 * root layout route instead. Provider order matches the former root layout
 * (Auth → Experiment → I18n → ErrorBoundary).
 */
export function RootProviders() {
  return (
    <AuthProvider>
      <ExperimentProvider>
        <I18nProvider>
          <ErrorBoundary>
            <ThemeApplier />
            <Outlet />
          </ErrorBoundary>
        </I18nProvider>
      </ExperimentProvider>
    </AuthProvider>
  );
}
